import composeGlobalSuccessMessaging from '../messaging/composeGlobalSuccessMessaging';
import composeGlobalFailureMessaging from '../messaging/composeGlobalFailureMessaging';
import composeGlobalNeutralMessaging from '../messaging/composeGlobalNeutralMessaging';
import composeMessaging from '../messaging/composeMessaging';
import { GLOBAL_MESSAGING_ID, STATUS_TYPES } from '../../constants/MessagingConstants';

export default function composeMessagingForBatchAction({ total, failures, successId, mixedId, failureId, values, useFormattedMessage = false }) {
  if (failures && failures.length > 0) {
    const successCount = total - failures.length;
    const failureCount = failures.length;

    // If there was only one item and it failed, show the error directly
    if (failureCount === 1 && successCount === 0) {
      return composeGlobalFailureMessaging(failures[0].errorResponseDTO, { values, useFormattedMessage });
    }

    const failureMessage = composeMessaging(
      STATUS_TYPES.Failure,
      GLOBAL_MESSAGING_ID,
      failureId,
      { values: { ...values, count: failureCount }, useFormattedMessage }
    );

    const neutralMessage = composeGlobalNeutralMessaging(
      mixedId,
      { values: { ...values, successCount, failureCount }, useFormattedMessage }
    );

    return successCount === 0 ? failureMessage : neutralMessage;
  }

  return composeGlobalSuccessMessaging(successId, { values, useFormattedMessage });
}



// WEBPACK FOOTER //
// ./app/helpers/borrowing/composeMessagingForBatchAction.js